import { AddAmbarRequestPorteragePersonnel } from "../../../../models/request/ambar/AddAmbarRequest";
import { GetAmbarByIdResponsePorteragePersonnel } from "../../../../models/response/ambar/GetAmbarByIdResponse";

/**
 * Siparişle birlikte gönderilecek hammaliye satırlarını hazırlar; mesai satırlarıyla aynı iki kural:
 *   1. "Hammaliye" anahtarı kapalıysa boş liste gönderilir — sunucu kayıtlı satırları pasife alsın.
 *   2. Personeli seçilmemiş satır gönderilmez.
 */
export const gonderilecekHammaliyeSatirlari = (
    _hammaliyeAcik: boolean,
    _satirlar: GetAmbarByIdResponsePorteragePersonnel[] | undefined
): AddAmbarRequestPorteragePersonnel[] => {
    if (!_hammaliyeAcik)
        return [];

    return (_satirlar ?? [])
        .filter(x => x != null && x.personnelId != undefined && x.personnelId != null && x.personnelId != '')
        .map(x => ({
            ambarPorteragePersonnelId: x.ambarPorteragePersonnelId,
            personnelId: x.personnelId,
            days: x.days?.toString(),
            description: x.description,
        }));
}
